import React from 'react'

const StyleSheet = ({
  url
}) => {
  return ( <link rel="stylesheet" type="text/css" href={ url }></link> )
}

export default StyleSheet